import { useEffect, useState } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsCarBooking';

const endpointVehiculos = ENDPOINTS.vehiculo;
const modeloVehiculo = Models.vehiculo;

const EMPTY = {
    idAsignacion: 0,
    idChofer: 0,
    idVehiculo: 0,
    fechaDesde: '',
    fechaHasta: '',
    comentarios: '',
    activo: true,
};

export default function ModalTab({
    open,
    mode = 'new',
    data = null,
    fkValue = 0, // idChofer
    onClose,
    onSubmit,
    inline = false,
}) {
    const [form, setForm] = useState({ ...EMPTY, idChofer: fkValue });
    const [errors, setErrors] = useState({
        idVehiculo: '',
        fechaDesde: '',
        comentarios: '',
    });
    const [vehiculosOptions, setVehiculosOptions] = useState([]);

    const validateField = (field, rawValue) => {
        const value = rawValue;
        let error = '';

        switch (field) {
            case 'idVehiculo':
                if (!value || Number(value) <= 0) error = 'Selecciona un vehículo.';
                break;
            case 'fechaDesde':
                if (!value) error = 'La fecha de inicio es obligatoria.';
                break;
            case 'comentarios':
                if (!value || !value.trim()) error = 'Agrega un comentario.';
                else if (value.length > 200) error = 'Máximo 200 caracteres.';
                break;
            default:
                break;
        }

        setErrors((prev) => ({ ...prev, [field]: error }));
        return !error;
    };

    const validateAll = () => {
        const fields = ['idVehiculo', 'fechaDesde', 'comentarios'];
        let isValid = true;
        fields.forEach(f => {
            if (!validateField(f, form[f])) isValid = false;
        });
        return isValid;
    };

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        validateField(field, value);
    };

    const loadVehiculos = async () => {
        try {
            const res = await axios.get(endpointVehiculos);
            const lista = (res.data || []).map((x) => modeloVehiculo(x));
            setVehiculosOptions(lista);
        } catch (e) {
            console.error('Error cargando catálogo de Vehículos', e);
        }
    };

    useEffect(() => {
        if (!open) return;
        loadVehiculos();
    }, [open]);

    useEffect(() => {
        if (mode === 'edit' && data) {
            const filled = {
                idAsignacion: data.idAsignacion ?? 0,
                idChofer: data.idChofer ?? fkValue ?? 0,
                idVehiculo: data.idVehiculo ?? 0,
                fechaDesde: data.fechaDesde ? data.fechaDesde.substring(0, 16) : '', // datetime-local format
                fechaHasta: data.fechaHasta ? data.fechaHasta.substring(0, 16) : '',
                comentarios: data.comentarios ?? '',
                activo: data.activo ?? true,
            };
            setForm(filled);
            // Validar campos iniciales
            validateField('idVehiculo', filled.idVehiculo);
            validateField('fechaDesde', filled.fechaDesde);
            validateField('comentarios', filled.comentarios);
        } else {
            setForm({
                ...EMPTY,
                idChofer: fkValue,
            });
            setErrors({});
        }
    }, [mode, data, fkValue]);

    if (!open) return null;

    const isSaveDisabled = !form.idVehiculo || !form.fechaDesde || !form.comentarios || Object.values(errors).some(e => !!e);

    const errorStyle = {
        color: '#b91c1c',
        fontSize: '.8rem',
        display: 'block',
        marginTop: '.25rem',
    };

    const Header = (
        <div className="roles-topbar" style={{ marginBottom: '0.6rem', paddingRight: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: '0 0 auto' }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nueva asignación de vehículo' : 'Editar asignación'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
        </div>
    );

    const Body = (
        <div style={{ paddingLeft: '15%', paddingRight: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.8rem', overflowY: 'auto', flex: '1 1 auto', minHeight: 0 }}>

            {/* Vehículo */}
            <div style={{ gridColumn: '1 / -1' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Vehículo:</label>
                <br /><br />
                <select
                    className={`infoField${errors.idVehiculo ? ' infoField--error' : ''}`}
                    value={form.idVehiculo || 0}
                    onChange={(e) => handleChange('idVehiculo', Number(e.target.value))}
                >
                    <option value={0}>— Selecciona vehículo —</option>
                    {vehiculosOptions.map((v) => (
                        <option key={v.idVehiculo} value={v.idVehiculo}>
                            {v.marca} {v.modelo} ({v.placa})
                        </option>
                    ))}
                </select>
                {errors.idVehiculo && <small style={errorStyle}>{errors.idVehiculo}</small>}
            </div>

            {/* Fecha Desde */}
            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Desde:</label>
                <br /><br />
                <input
                    type="datetime-local"
                    className={`infoField${errors.fechaDesde ? ' infoField--error' : ''}`}
                    onKeyDown={(e) => e.preventDefault()}
                    value={form.fechaDesde}
                    onChange={(e) => handleChange('fechaDesde', e.target.value)}
                />
                {errors.fechaDesde && <small style={errorStyle}>{errors.fechaDesde}</small>}
            </div>

            {/* Fecha Hasta */}
            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Hasta (Opcional):</label>
                <br /><br />
                <input
                    type="datetime-local"
                    className="infoField"
                    onKeyDown={(e) => e.preventDefault()}
                    value={form.fechaHasta}
                    onChange={(e) => handleChange('fechaHasta', e.target.value)}
                />
            </div>

            {/* Comentarios */}
            <div style={{ gridColumn: '1 / -1' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Comentarios:</label>
                <br /><br />
                <textarea
                    className={`infoField${errors.comentarios ? ' infoField--error' : ''}`}
                    value={form.comentarios}
                    onChange={(e) => handleChange('comentarios', e.target.value)}
                    rows={3}
                    maxLength={200}
                />
                {errors.comentarios && <small style={errorStyle}>{errors.comentarios}</small>}
            </div>

        </div>
    );

    const Footer = (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', marginTop: '.8rem', paddingRight: 16, flex: '0 0 auto' }}>
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={() => {
                    if (validateAll()) onSubmit(form, mode);
                }}
                disabled={isSaveDisabled}
                style={{ opacity: isSaveDisabled ? 0.5 : 1, cursor: isSaveDisabled ? 'not-allowed' : 'pointer' }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    if (inline) {
        return (
            <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {Header}
                {Body}
                {Footer}
            </div>
        );
    }

    return (
        <div className="roles-confirm-overlay" role="dialog" aria-modal="true"
            style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 1000 }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        >
            <div className="roles-confirm-card"
                style={{ width: 'min(720px, 96vw)', maxHeight: '85vh', background: '#fff', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,.25)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
            >
                {Header}
                {Body}
                {Footer}
            </div>
        </div>
    );
}
